import { useEffect, useState } from 'react'
import type { TrainingMatrixViewDto } from '../API/rtk-query-api/store/tmsApi'
import { useGetTrainingMatrixViewsQuery } from '../API/rtk-query-api/store/tmsApi'
import type { ErrorResponse } from '../redux/types/common'

export const useTrainingMatrixViews = (fetchViews = true) => {
  const [views, setViews] = useState<Array<TrainingMatrixViewDto>>([])
  const { data, isFetching, isLoading, refetch, isError, error } = useGetTrainingMatrixViewsQuery(
    {},
    { skip: fetchViews === false }
  )

  useEffect(() => {
    if (data && !isFetching && !isLoading) {
      setViews(data.data ?? [])
    }
  }, [data, isFetching, isLoading])

  return { views: views, isFetching: isFetching || isLoading, refetch, isError, error: error as ErrorResponse }
}
